module.exports = __webpack_public_path__ + "img/pump.6da12a37.jpg";